import React, { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Menu, X, Phone, Globe } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const {
    language,
    setLanguage,
    t
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };
  const navLinks = [{
    id: 'about',
    labelEn: 'About',
    labelEs: 'Sobre nosotros'
  }, {
    id: 'services',
    labelEn: 'Services',
    labelEs: 'Servicios'
  }, {
    id: 'process',
    labelEn: 'Process',
    labelEs: 'Proceso'
  }, {
    id: 'faq',
    labelEn: 'FAQ',
    labelEs: 'Preguntas'
  }, {
    id: 'locations',
    labelEn: 'Locations',
    labelEs: 'Ubicaciones'
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 font-sans" data-id="element-74">
      {/* Top Utility Bar */}
      <div className="bg-[#0f172a] text-white py-2 px-4 sm:px-6 lg:px-8 text-xs sm:text-sm font-medium" data-id="element-75">
        <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-76">
          <span className="opacity-80 hidden sm:inline-block tracking-wide" data-id="element-77">
            Lehigh Valley Weight Loss — Allentown, PA
          </span>
          <div className="flex items-center space-x-4 sm:space-x-6 ml-auto" data-id="element-78">
            <a href="tel:4844084100" className="flex items-center hover:text-teal-400 transition-colors" data-id="element-79">
              <Phone className="w-3.5 h-3.5 mr-1.5" data-id="element-80" />
              <span className="hidden xs:inline sm:inline" data-id="element-81">484-408-4100</span>
              <span className="sm:hidden" data-id="element-82">Call Now</span>
            </a>
            <div className="flex items-center space-x-2 border-l border-slate-700 pl-4 sm:pl-6" data-id="element-83">
              <Globe className="w-3.5 h-3.5 opacity-70 hidden sm:block" data-id="element-84" />
              <button onClick={() => setLanguage('en')} className={`hover:text-white transition-colors px-1 ${language === 'en' ? 'text-white font-bold' : 'text-slate-400'}`} data-id="element-85">
                EN
              </button>
              <span className="text-slate-600" data-id="element-86">|</span>
              <button onClick={() => setLanguage('es')} className={`hover:text-white transition-colors px-1 ${language === 'es' ? 'text-white font-bold' : 'text-slate-400'}`} data-id="element-87">
                ES
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Nav Bar */}
      <div className={`bg-white transition-all duration-300 border-b border-slate-100 ${isScrolled ? 'shadow-md py-2.5' : 'py-3 md:py-5'}`} data-id="element-88">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-89">
          <div className="flex justify-between items-center" data-id="element-90">
            {/* Logo Area */}
            <div className="flex flex-col cursor-pointer" onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} data-id="element-91">
              <span className="text-base sm:text-xl md:text-2xl font-extrabold text-[#0f172a] tracking-tight leading-none" data-id="element-92">
                Lehigh Valley Weight Loss
              </span>
              <span className="text-xs text-slate-500 font-medium mt-0.5 tracking-wide hidden sm:block" data-id="element-93">
                Maneesh Ailawadi, MD, FSSO
              </span>
            </div>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center space-x-8" data-id="element-94">
              {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="text-sm font-semibold text-slate-600 hover:text-[#0d9488] transition-colors uppercase tracking-wide" data-id="element-95">
                  {language === 'en' ? link.labelEn : link.labelEs}
                </button>)}
              <a href="tel:4844084100" className="bg-[#0d9488] hover:bg-[#0f766e] text-white px-6 py-2.5 rounded-full font-bold text-sm transition-all shadow-sm hover:shadow-md transform hover:-translate-y-0.5 flex items-center" data-id="element-96">
                <Phone className="w-4 h-4 mr-2" data-id="element-97" />
                484-408-4100
              </a>
            </nav>

            {/* Mobile Menu Button */}
            <div className="lg:hidden" data-id="element-98">
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-[#0f172a] p-2 hover:bg-slate-50 rounded-md transition-colors" aria-label="Toggle menu" data-id="element-99">
                {isMobileMenuOpen ? <X className="w-7 h-7" data-id="element-100" /> : <Menu className="w-7 h-7" data-id="element-101" />}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-102">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-slate-200 shadow-xl overflow-hidden absolute w-full" data-id="element-103">
            <div className="px-4 py-5 space-y-3" data-id="element-104">
              {navLinks.map(link => <button key={link.id} onClick={() => scrollToSection(link.id)} className="block w-full text-left py-3 px-4 text-base font-semibold text-slate-700 hover:bg-slate-50 hover:text-[#0d9488] rounded-lg transition-colors border-b border-slate-50 last:border-0" data-id="element-105">
                  {language === 'en' ? link.labelEn : link.labelEs}
                </button>)}
              <div className="pt-3 mt-2 border-t border-slate-100" data-id="element-106">
                <a href="tel:4844084100" className="flex items-center justify-center w-full py-3.5 bg-[#0d9488] text-white rounded-lg font-bold shadow-sm" data-id="element-107">
                  <Phone className="w-4 h-4 mr-2" data-id="element-108" />
                  484-408-4100
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}